/**
 * Default export.
 *
 * @param Vue
 */
export default (Vue) => {
  Vue.component('f-select-car', () => import('./select-car'))
  Vue.component('f-select-visitor', () => import('./select-visitor'))
}



// WEBPACK FOOTER //
// ./src/components/form/fields/dweller/index.js